import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import DoorRender from "./SaleDoorRender";

const SpecDoorFullscreen = ({ isOpen, onClose, specifications, workOrder }) => {
    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [isOpen, onClose]);

    if (!isOpen || workOrder.product !== "Door") return null;

    return createPortal(
        <div
            className="fixed inset-0 flex flex-col bg-white"
            role="dialog"
            aria-modal="true"
            aria-label="Specifications and door preview"
            style={{ zIndex: 200000, isolation: "isolate" }}
        >
            <div className="flex shrink-0 items-center justify-end border-b border-ink-100 px-3 py-2">
                <button
                    type="button"
                    onClick={onClose}
                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-ink-200 bg-ink-50 text-ink-500 transition-colors hover:bg-ink-100 hover:text-ink-700"
                    aria-label="Exit fullscreen"
                    title="Exit fullscreen"
                >
                    <i className="fas fa-compress" aria-hidden="true" />
                </button>
            </div>
            <div
                className="min-h-0 min-w-0 flex-1 overflow-hidden p-3 sm:p-4"
                style={{ display: "grid", gridTemplateColumns: "1fr 3fr", gap: "1rem" }}
            >
                <section className="flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-ink-100 bg-white">
                    <h3 className="detail-section-title shrink-0 border-b border-ink-100 px-3 py-3 sm:px-5 sm:py-4">
                        Specifications
                    </h3>
                    <div className="min-h-0 flex-1 basis-0 overflow-y-auto px-3 py-3 sm:px-5 sm:py-4">
                        {specifications}
                    </div>
                </section>
                <section className="flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-ink-100 bg-white">
                    <h3 className="detail-section-title shrink-0 border-b border-ink-100 px-3 py-3 sm:px-5 sm:py-4">
                        Door Preview
                    </h3>
                    <div className="min-h-0 flex-1 overflow-x-auto overflow-y-auto">
                        <DoorRender selectedSale={workOrder} />
                    </div>
                </section>
            </div>
        </div>,
        document.body,
    );
};

export default SpecDoorFullscreen;
